/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Product } from "@coveo/headless/commerce";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useCoveoSearch from "@NA/Components/Coveo/Commerce/useCoveoSearch";
import { ProductSuggestionSkeletonLoader } from "@NA/Components/Coveo/CoveoSkeletonBox";
import { CoveoProductModel } from "@NA/Types/CoveoModel";
import ADIColors from "@NA/Utils/ADIColors";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { css } from "styled-components";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import { FormFieldStyle } from "@insite/mobius/FormField";
import CoveoProductAddToCartButtonSearch from "@NA/Components/Coveo/ProductCardView/CoveoProductAddToCartButtonSearch";
import CoveoProductListProductContext from "@NA/Components/Coveo/Contexts/CoveoProductListProductContext";
import { StyledButton } from "@insite/mobius/Clickable";
import cloneDeep from "lodash/cloneDeep";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";

interface OwnProps {
    focusedItem?: CoveoProductModel;
    extendedStyles?: AutocompleteProductsStyles;
    clearSearch: () => void;
    closeAutocomplete: () => void;
    openDealerModal: (coveoProduct: CoveoProductModel) => void;
    query?: string;
}

const mapStateToProps = (state: CustomApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
    language: state.context.session.language,
    roles: state.context.session.userRoles,
    currencySymbol: state.context.session.currency?.currencySymbol ?? "",
    settingsCollection: getSettingsCollection(state),
    isPendingVerification: state.ADIGlobalData.PricingStatusStore.isPendingVerification,
});

export interface AutocompleteProductsStyles {
    autocompleteColumnWrapper?: InjectableCss;
    headerText?: TypographyPresentationProps;
    container?: GridContainerProps;
    focusedContainer?: GridContainerProps;
    imageGridItem?: GridItemProps;
    image?: LazyImageProps;
    infoGridItem?: GridItemProps;
    titleLink?: LinkPresentationProps;
    erpNumberText?: TypographyPresentationProps;
    headerContainer?: GridContainerProps;
    headerGridItem?: GridItemProps;
    headerProductCount?: TypographyPresentationProps;
    saveText?: TypographyProps;
    priceText?: TypographyProps;
    oldPrice?: TypographyProps;
    RightGridItem?: GridItemProps;
    addtocartButtonGridItem?: GridItemProps;
    priceGridItem?: GridItemProps;
    addToCartButton?: ButtonPresentationProps;
    unitListPrice?: TypographyProps;
    inventoryInStock?: TypographyProps;
    inventoryLowStock?: TypographyProps;
    inventoryDefault?: TypographyProps;
    moreOptionAvailable?: TypographyProps;
    inventoryTextDesign?: TypographyProps;
    addToCartButtonDisabled?: ButtonPresentationProps;
    dealerCertification?: InjectableCss;
}

export const autocompleteProductsStyles: AutocompleteProductsStyles = {
    dealerCertification: {
        css: css`
            cursor: default;
            &:hover,
            &:focus,
            &:active,
            span:hover,
            span:focus,
            span:active {
                outline: none;
                text-decoration: none;
            }
        `,
    },
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            padding: 0 15px;
            flex: 1;
            width: 100%;
            &.testWrapperBox.onlyProduct {
                padding: 0px;
            }
            &:last-child:not(:only-child) {
                border-left: 1px solid ${getColor("common.border")};
                width: 65%;
                > div:first-child {
                    padding-bottom: 7px;
                    border-bottom: 1px solid ${ADIColors.gray2};
                }
                > div:nth-child(2) {
                    padding-top: 10px;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border: none !important;
                        padding: 0px !important;
                        &:last-child:not(:only-child) {
                            flex: unset;
                            width: 100%;
                        }
                    `,
                    css`
                        border: none !important;
                        padding: 0px !important;
                    `,
                    css`
                        width: 35%;
                        &:last-child:not(:only-child) {
                            width: 65%;
                            flex: unset;
                        }
                    `,
                    css`
                        &:only-child {
                            width: 100%;
                        }
                        width: 35%;
                        &:last-child:not(:only-child) {
                            width: 65%;
                        }
                    `,
                    css`
                        &:only-child {
                            width: 100%;
                        }
                        width: 35%;
                        &:last-child:not(:only-child) {
                            width: 65%;
                        }
                    `,
                ])}
        `,
    },
    headerContainer: {
        css: css`
            &.headerOnlyProduct {
                padding-bottom: 10px;
                margin-bottom: 10px;
                border-bottom: 1px solid ${ADIColors.gray2};
            }
        `,
    },
    headerText: {
        weight: "bold",
        css: css`
            text-align: left;
            font-style: normal;
            color: ${ADIColors.darkBlack3};
            font-size: 16px;
            font-weight: 700;
            line-height: normal;
            white-space: nowrap;
        `,
    },
    saveText: {
        css: css`
            color: ${ADIColors.black};
            font-size: 12px;
            font-weight: bold;
            line-height: normal;
            padding-top: 4px;
        `,
    },
    priceText: {
        css: css`
            color: ${ADIColors.gray4};
            font-size: 12px;
            font-weight: bold;
            text-decoration: line-through;
            padding-top: 4px;
        `,
    },
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
            margin: 0 0 10px !important;
            ${GridOffset} {
                flex-wrap: nowrap;
                gap: 10px;
                align-items: center;
                margin-bottom: 10px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            align-items: center;
                        `,
                        css`
                            align-items: center;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            @media (min-width: 375px) and (max-width: 767px) {
                max-width: inherit;
            }
            &:last-child {
                margin: 0px !important;
                ${GridOffset} {
                    margin-bottom: 0px;
                }
            }
        `,
    },
    focusedContainer: {
        gap: 0,
        css: css`
            flex-grow: 0;
            margin: 0 0 8px !important;
            background-color: lightgray;
            @media (min-width: 375px) and (max-width: 767px) {
                max-width: inherit;
            }
        `,
    },
    imageGridItem: {
        width: 3,
        css: css`
            max-width: 65px;
            max-height: 50px;
            flex-basis: 65px;
            flex: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0px !important;
                    `,
                    css`
                        margin-top: 0px !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    RightGridItem: {
        width: 12,
        css: css`
            gap: 10px;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 70%;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0px;
                    `,
                    css`
                        flex-basis: 70%;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    image: {
        width: "55px",
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    infoGridItem: {
        width: 9,
        css: css`
            flex-direction: column;
            max-width: calc(100% - 65px);
            flex-basis: calc(100% - 65px);
            flex-basis: auto;
            max-width: initial;
            margin-left: 0 !important;
            margin-right: auto !important;
            flex: auto;
        `,
    },
    titleLink: {
        typographyProps: {
            ellipsis: false,
            css: css`
                width: 100%;
                text-align: left;
                margin: 0;
                font-size: 14px;
                font-weight: 600;
                line-height: normal;
                cursor: pointer;
                font-style: normal;
                padding-left: 0;
                color: ${getColor("text.main")} !important;
                display: -webkit-box !important;
                line-clamp: 2 !important;
                -webkit-line-clamp: 2 !important;
                -webkit-box-orient: vertical;
                overflow: hidden !important;
                &:hover {
                    text-decoration: underline;
                }
            `,
        },
        css: css`
            width: 100%;
            margin: 0;
        `,
    },
    erpNumberText: {
        ellipsis: false,
        css: css`
            width: 100%;
            text-align: left;
            margin: 3px 0;
            font-size: 12px;
            font-weight: 400;
            line-height: normal;
            color: ${ADIColors.darkBlack3};
            font-style: normal;
        `,
    },
    headerGridItem: {
        css: css`
            display: flex;
            flex-direction: row;
            flex-basis: 100%;
            max-width: 100%;
            align-items: baseline;
            margin: 0px !important;
            justify-content: space-between;
        `,
    },
    headerProductCount: {
        css: css`
            font-family: "Nunito Sans";
            color: rgb(102, 102, 102);
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            padding: 0px 5px;
            width: 100%;
            p {
                margin-right: 10px;
                display: -webkit-box !important;
                line-clamp: 1 !important;
                -webkit-line-clamp: 1 !important;
                -webkit-box-orient: vertical;
                overflow: hidden !important;
            }
            ${StyledButton} {
                color: ${ADIColors.blue1};
                font-size: 14px;
                font-weight: 700;
                margin: 0px;
                white-space: nowrap;
                &:hover {
                    text-decoration: underline;
                }
                > ${TypographyStyle} {
                    color: ${ADIColors.blue1};
                    font-size: 14px;
                    font-weight: 700;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
    oldPrice: {
        css: css`
            padding-left: 5px;
            color: ${ADIColors.gray4};
            font-size: 12px;
            font-weight: bold;
            text-decoration: line-through;
            padding-top: 4px;
        `,
    },
    addtocartButtonGridItem: {
        width: [12],
        css: css`
            align-items: flex-end;
            display: inline-block;
            flex-basis: 100px;
            max-width: 100px;
            min-width: 100px;
            display: flex;
            gap: 10px;
            align-items: center;
            > ${ButtonWrapper} {
                width: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-top: 5px;
                        `,
                        css`
                            margin-top: 5px;
                        `,
                        null,
                        null,
                        null,
                    ])}
                &:hover {
                    background: ${ADIColors.blue5};
                    color: ${ADIColors.white} !important;
                    border: none;
                }
            }
        `,
    },
    priceGridItem: {
        width: [12],
        css: css`
            display: flex;
            gap: 10px;
            align-items: center;
            flex-basis: max-content;
            max-width: max-content;
            min-width: max-content;

            ${FormFieldStyle} {
            }
            > ${ButtonWrapper} {
                width: 100%;
                &:hover {
                    background: ${ADIColors.blue5};
                    color: ${ADIColors.white} !important;
                    border: none;
                }
            }
        `,
    },
    inventoryInStock: {
        css: css`
            color: ${ADIColors.lightGreen2};
            font-size: 12px;
            font-weight: bold;
        `,
    },
    inventoryLowStock: {
        css: css`
            color: ${ADIColors.orange2};
            font-size: 12px;
            font-weight: bold;
        `,
    },
    inventoryDefault: {
        css: css`
            color: ${ADIColors.gray4};
            font-size: 12px;
            font-weight: bold;
        `,
    },
    moreOptionAvailable: {
        css: css`
            color: ${ADIColors.darkBlack3};
            font-size: 12px;
            font-weight: 700;
        `,
    },
    unitListPrice: {
        css: css`
            color: ${ADIColors.black};
            font-size: 16px;
            font-weight: bold;
        `,
    },

    addToCartButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            max-width: 100px;
            border: solid 1px ${ADIColors.blue1}!important;
            font-size: 12px;
            font-weight: 700;
            color: ${ADIColors.blue1};
            border-radius: 4px;
            padding: 0 10px;
            margin: 0;
            max-height: 25px;
            min-height: 25px;
            > ${TypographyStyle} {
                font-size: 12px;
                font-weight: 700;
                color: ${ADIColors.blue1};
            }
            &:hover {
                > ${TypographyStyle} {
                    font-size: 12px;
                    font-weight: 700;
                    color: ${ADIColors.white};
                }
            }
            &:disabled {
                cursor: not-allowed;
                opacity: 0.5;
                &:hover {
                    background-color: ${ADIColors.white};
                    color: ${ADIColors.blue1};
                    > ${TypographyStyle} {
                        color: ${ADIColors.blue1};
                    }
                }
            }
            img {
                max-height: 25px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        button {
                            color: ${ADIColors.white};
                            border: 0;
                            border-top: 1px solid ${ADIColors.gray7};
                        }
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    addToCartButtonDisabled: {
        variant: "secondary",
        css: css`
            width: 100%;
            max-width: 100px;
            font-size: 12px;
            font-weight: 700;
            color: ${ADIColors.blue1};
            border-radius: 4px;
            padding: 0 10px;
            margin: 0;
            max-height: 25px;
            min-height: 25px;
            border: 2px solid ${ADIColors.blue5};
            cursor: not-allowed;
            opacity: 0.5;
            > ${TypographyStyle} {
                font-size: 12px;
                font-weight: 700;
                color: ${ADIColors.blue1};
            }
            img {
                max-height: 25px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        button {
                            color: ${ADIColors.white};
                            border: 0;
                            border-top: 1px solid ${ADIColors.gray7};
                        }
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasCoveoHooks;

const Styles = autocompleteProductsStyles;

const CoveoAutocompleteProducts = ({
    extendedStyles,
    clearSearch,
    closeAutocomplete,
    openDealerModal,
    isAuthenticated,
    searchBox,
    instantProducts,
    queryTrigger,
    query: queryProp,
    isPendingVerification,
}: Props) => {
    const styles = mergeToNew(Styles, extendedStyles);
    const history = useHistory();
    const { doCoveoSearch, clearCoveoSearch } = useCoveoSearch();
    const [coveoProducts, setCoveoProducts] = useState<CoveoProductModel[]>([]);
    const [isScrolling, setIsScrolling] = useState(false);
    const targetAvailability = ["in stock", "low stock", "discontinued", "special order"];
    const [btnIsHidden, setBtnIsHidden] = useState(false);
    const [coveoProductsCount, setCoveoProductsCount] = useState(5);

    const { state: searchBoxState } = searchBox;
    const { state: instantProductsState, methods: instantProductsMethods } = instantProducts;
    const { state: queryTriggerState } = queryTrigger;

    const query = queryProp || queryTriggerState?.newQuery;

    const handleProductClick = (event: React.SyntheticEvent, product: CoveoProductModel) => {
        product.interactiveProduct?.select();
        if (isScrolling) {
            event.preventDefault();
            return;
        }
        history.push(product.canonicalUrl);
        clearSearch();
        closeAutocomplete();
        clearCoveoSearch();
    };

    useEffect(() => {
        const coveoProducts: CoveoProductModel[] = [];
        instantProductsState?.products.forEach((_product: Product) => {
            const product = cloneDeep(_product);
            if (!instantProductsMethods) {
                return;
            }
            product.ec_price = product.ec_price ?? 0;
            const interactiveProduct = instantProductsMethods?.interactiveProduct({
                options: { product },
            });
            const ec_erp_number: any[string] = product.additionalFields?.ec_erp_number;
            const erp_number = ec_erp_number ? (ec_erp_number[0] as string) : "";
            const ec_product_id = product.additionalFields?.ec_product_id;
            const pid = ec_product_id as string;
            const groupId = product.additionalFields?.ec_item_group_id as string;

            let variantTypeId = null;
            if (groupId && !groupId.includes(pid)) {
                variantTypeId = pid;
            }
            let minimumOrderQty = product.additionalFields?.ec_minimum_qty as string;
            minimumOrderQty = minimumOrderQty === "0" ? "1" : minimumOrderQty;

            coveoProducts.push({
                title: product.ec_name as string,
                category: product.ec_category as [],
                brandName: product.ec_brand as string,
                shortDescription: product.ec_shortdesc as string,
                productNumber: erp_number as string,
                manufacturerItem: product.additionalFields?.ec_manufacturer_item as string,
                availability: product.additionalFields?.ec_availability as [],
                urlSegment: product.additionalFields?.ec_product_url_segment as string,
                imageAltText: product.additionalFields?.imagealttext as string,
                mediumImagePath: product.additionalFields?.mediumimagepath as string,
                smallImagePath: product.additionalFields?.smallimagepath as string,
                variantTypeId,
                canAddToCart: false,
                quoteRequired: product.additionalFields?.quoteRequired as boolean,
                minimumOrderQty: minimumOrderQty as string,
                allowZeroPricing: product.additionalFields?.ec_allow_zero_pricing as boolean,
                unitListPrice: product.additionalFields?.ec_unit_list_price as number,
                vendorAuthRequiredList: product.additionalFields?.ec_vendor_auth_required_list as string,
                vendorAuthRequiredLink: product.additionalFields?.ec_vendor_auth_required_link as string,
                unitofmeasure: product.additionalFields?.ec_unit_measure as string,
                productId: pid as string,
                canonicalUrl: product.additionalFields?.ec_canonical_url as string,
                pricing: null,
                featureBullets1to3: product.additionalFields?.ec_featurebullets1to3 as string,
                classificatioN_CODE: product.additionalFields?.ec_classification_code as string,
                saleType: product.additionalFields?.ec_saletype as string,
                onSaleNow: product.additionalFields?.ec_onSaleNow as string,
                brandUrlSegment: product.additionalFields?.ec_brand_url_segment as string,
                isNewProduct: product.additionalFields?.ec_isnewproduct as string,
                showAuthorizationRequired: false,
                responseId: "",
                position: product.position,
                interactiveProduct,
                modelNumber: product.additionalFields?.ec_model_number as string,
                logicBroker: product.additionalFields?.ec_logicbroker as string,
            });
        });

        setCoveoProducts(coveoProducts);
    }, [instantProductsState]);

    useEffect(() => {
        const handleTouchMove = () => {
            setIsScrolling(true);
        };

        const handleTouchEnd = () => {
            setIsScrolling(false);
        };

        const updateProductCount = () => {
            const windowHeight = window.innerHeight;
            if (windowHeight > 513) {
                setCoveoProductsCount(5);
            } else {
                setCoveoProductsCount(4);
            }
        };
        updateProductCount();

        window.addEventListener("resize", updateProductCount);
        document.addEventListener("touchmove", handleTouchMove);
        document.addEventListener("touchend", handleTouchEnd);

        return () => {
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("touchend", handleTouchEnd);
            window.removeEventListener("resize", updateProductCount);
        };
    }, []);

    const isLoading = instantProductsState?.isLoading;
    if (!instantProductsState && !isLoading) {
        return null;
    }

    let displayItem = false;
    if (!searchBoxState?.suggestions || searchBoxState.suggestions.length === 0) {
        displayItem = false;
    } else {
        displayItem = true;
    }
    return (
        <StyledWrapper
            {...styles.autocompleteColumnWrapper}
            className={`${displayItem ? "testWrapperBox" : "testWrapperBox onlyProduct"}`}
        >
            <GridContainer {...styles.headerContainer} className={`${displayItem ? "" : "headerOnlyProduct"}`}>
                <GridItem {...styles.headerGridItem}>
                    <Typography {...styles.headerText}>{translate("Products")}</Typography>
                    <Typography {...styles.headerProductCount}>
                        <p>
                            {" "}
                            {translate(
                                ` (showing ${coveoProducts.slice(0, coveoProductsCount).length || 0} of ${
                                    instantProductsState?.totalCount || 0
                                })`,
                            )}
                        </p>
                        {query && query.trim() && (
                            <Link
                                onClick={() => {
                                    doCoveoSearch(query);
                                    clearSearch();
                                    closeAutocomplete();
                                }}
                            >
                                {translate("See All Results")}
                            </Link>
                        )}
                    </Typography>
                </GridItem>
            </GridContainer>
            {isLoading && <ProductSuggestionSkeletonLoader numberOfSuggestions={coveoProductsCount} />}
            {!isLoading &&
                coveoProducts.slice(0, coveoProductsCount).map((product: CoveoProductModel) => {
                    return (
                        <GridContainer {...styles.container} key={product.productId as string}>
                            {product.shortDescription && (
                                <>
                                    <GridItem {...styles.imageGridItem}>
                                        <Link
                                            onClick={e => handleProductClick(e, product)}
                                            onMouseDown={e => handleProductClick(e, product)}
                                        >
                                            <LazyImage
                                                {...styles.image}
                                                src={
                                                    (product.smallImagePath as string) === null
                                                        ? "https://cdn.adiglobaldistribution.us/userfile-na/US/UserFiles/Images/Products/MD_NotFound.jpg"
                                                        : product.smallImagePath
                                                }
                                            />
                                        </Link>
                                    </GridItem>
                                    <GridItem {...styles.RightGridItem}>
                                        <GridItem {...styles.infoGridItem}>
                                            <Link
                                                {...styles.titleLink}
                                                href={product.canonicalUrl}
                                                onClick={e => handleProductClick(e, product)}
                                                onMouseDown={e => handleProductClick(e, product)}
                                            >
                                                {product.shortDescription}
                                            </Link>

                                            {product.manufacturerItem ? (
                                                <Typography {...styles.erpNumberText}>
                                                    {product.manufacturerItem} | {product.productNumber}
                                                </Typography>
                                            ) : (
                                                <Typography {...styles.erpNumberText}>
                                                    {product.productNumber}
                                                </Typography>
                                            )}

                                            {product?.availability ? (
                                                <div>
                                                    {product.availability
                                                        .filter(item =>
                                                            targetAvailability.some(
                                                                target =>
                                                                    (item as string)?.toLowerCase() ===
                                                                    target?.toLowerCase(),
                                                            ),
                                                        )
                                                        .map((matchedItem: string, index) => {
                                                            // Ensure case-insensitive comparison for assigning styles
                                                            const inventoryTextDesign =
                                                                matchedItem?.toLowerCase() == "in stock"
                                                                    ? styles.inventoryInStock
                                                                    : matchedItem?.toLowerCase() === "low stock"
                                                                    ? styles.inventoryLowStock
                                                                    : styles.inventoryDefault;

                                                            return (
                                                                <>
                                                                    {isAuthenticated && (
                                                                        <Typography
                                                                            {...inventoryTextDesign}
                                                                            key={index}
                                                                        >
                                                                            {matchedItem}
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            );
                                                        })}

                                                    {product.availability &&
                                                        product.variantTypeId &&
                                                        isAuthenticated && (
                                                            <Typography {...styles.moreOptionAvailable}> | </Typography>
                                                        )}
                                                    <Typography {...styles.moreOptionAvailable}>
                                                        {product.variantTypeId && translate("More Options Available")}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                        </GridItem>
                                        {/* Phase 2 */}
                                        {/* {(product.vendorAuthRequiredList?.toLowerCase() === "false" && isAuthenticated) ? (
                                            <GridItem {...styles.priceGridItem}>
                                                <Typography {...styles.unitListPrice}>{product.unitListPrice}</Typography>
                                            </GridItem>
                                        ) : null} */}
                                        {/* Phase 2 */}
                                        <GridItem {...styles.addtocartButtonGridItem}>
                                            {!btnIsHidden && isAuthenticated && !isPendingVerification && (
                                                <CoveoProductListProductContext coveoProduct={product}>
                                                    <CoveoProductAddToCartButtonSearch
                                                        data-test-selector={`actionsAddToCart${product?.productId}`}
                                                        extendedStyles={styles.addToCartButton}
                                                        btnIsHidden={btnIsHidden}
                                                        openDealerModal={openDealerModal}
                                                    />
                                                </CoveoProductListProductContext>
                                            )}
                                        </GridItem>
                                    </GridItem>
                                </>
                            )}
                        </GridContainer>
                    );
                })}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withCoveoHooks(CoveoAutocompleteProducts));
